export enum TransportOptionType {
  SchoolCarrier = 1,
  Personal,
  PersonalPassenger,
  AuthorizedCarrier,
  CompanionInPublicTransport
}
